export default theme => ({
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: 56,
        color: theme.palette.text.secondary,
    },
    refreshButton: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    settingsMenuRow: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    settingsMenuLabel: {
        fontSize: 15,
        paddingLeft: 5,
        color: '#66788A',
    },
    infoPopoverContent: {
        fontSize: 14,
        color: '#66788A',
        padding: theme.spacing(2),
        maxWidth: 360,
        lineHeight: 1.45,
    },
    content: {
        alignContent: 'space-around',
        textAlign: 'center',
    },
    loadingContainer: {
        textAlign: 'center',
        padding: '20px',
    },
    noData: {
        padding: '20px',
    },
    summary: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        padding: theme.spacing(1, 2),
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '13px',
        color: theme.palette.text.secondary,
    },
    summaryItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        cursor: 'pointer',
    },
    summaryDot: {
        width: 12,
        height: 12,
        borderRadius: '50%',
        display: 'inline-block',
    },
    nodeToggle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    nodeToggleLabel: {
        marginRight: 8,
    },
    updateRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 8,
    },
    updateInner: {
        display: 'flex',
        alignItems: 'center',
    },
    updateAvatar: {
        width: 28,
        height: 28,
        backgroundColor: '#ffffff',
    },
    updateIcon: {
        fontSize: 18,
        color: '#000000',
    },
    updateText: {
        fontWeight: 500,
    },
    metricsRow: {
        display: 'flex',
        justifyContent: 'space-around',
        padding: '12px 16px 4px',
        gap: '12px',
    },
    metricCard: {
        flex: 1,
        textAlign: 'center',
        padding: '8px 4px',
        borderRadius: 6,
        backgroundColor: '#fafafa',
        border: '1px solid #eee',
    },
    metricValue: {
        fontSize: '1.6rem',
        fontWeight: 700,
        lineHeight: 1.2,
    },
    metricLabel: {
        fontSize: '0.75rem',
        color: '#66788A',
        marginTop: 2,
    },
    portletFooter: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    periodButton: {
        fontSize: '15px',
        float: 'left',
        color: '#66788A',
    },
});
